/**
 * This file contains the sizes which will trigger the consent before leaving Stage
 */

import { Platform } from '@jaimo-solutions-gmbh/platform-services-module/lib/platforms';

export const blacklist: Record<Platform, string[]> = {
  youtube: ['youtube.com'],
  facebook: ['facebook.com'],
  'x-twitter': ['twitter.com', 't.co/', 'x.com', 'x.co'],
  instagram: ['instagram.com'],
  linkedin: ['linkedin.com'],
  tiktok: ['tiktok.com'],
  threads: ['threads.net'],
  bluesky: ['bsky.app'],
  rss: [],
  'stage-ai': [],
  mastodon: [],

};

export const isBlacklisted = (url: string) => {
  if (!url) {return false;}

  const platforms = Object.keys(blacklist) as Platform[];

  return platforms.some((platform: Platform) =>
    blacklist[platform]?.some((blacklisted) => url.includes(blacklisted))
  );
};

export const getPlatformByUrl = (url: string): Platform | undefined => {
  if (!url) {return;}

  const platforms = Object.keys(blacklist) as Platform[];

  return platforms.find((platform: Platform) =>
    blacklist[platform]?.find((blacklisted) => url.includes(blacklisted))
  );
};
